// extracted by mini-css-extract-plugin
export var tosLink = "_bp-0";